// extracted by mini-css-extract-plugin
export default {"root":"S65rd8Y9a7WEOr6fsCGk","edit":"DJBQmZqx1NOKil8TzNOg","pencil":"DewULOlPa_dfliDMDLGc"};